import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/app/environments/environment';
import {
  CompanyModel,
  SubscriptionModel,
} from '../models/company-management/company-management.model';

@Injectable({
  providedIn: 'root',
})
export class CompanyManagementService {
  private companyApiUrl = environment.companyApiUrl;
  constructor(private http: HttpClient) {}

  getCompanies(
    status?: number,
    companyInclude?: number,
    pageNumber?: number,
    pageSize?: number,
    searchTerm?: string, // moved to last parameter
  ) {
    let url = `${this.companyApiUrl}/Companies`;
    const params: string[] = [];

    if (status !== undefined) {
      params.push(`Status=${status}`);
    }
    if (companyInclude !== undefined) {
      params.push(`CompanyInclude=${companyInclude}`);
    }
    if (pageNumber !== undefined) {
      params.push(`PageNumber=${pageNumber}`);
    }
    if (pageSize !== undefined) {
      params.push(`PageSize=${pageSize}`);
    }
    if (searchTerm !== undefined && searchTerm.trim().length > 0) {
      params.push(`SearchTerm=${encodeURIComponent(searchTerm.trim())}`);
    }

    if (params.length > 0) {
      url += '?' + params.join('&');
    }

    return this.http.get<CompanyModel[]>(url);
  }

  validateCompany(company: CompanyModel) {
    const url = `${this.companyApiUrl}/Companies/Validate`;
    return this.http.post(url, company);
  }
  getCompanyById(companyId: number) {
    const url = `${this.companyApiUrl}/Companies/${companyId}`;
    return this.http.get<CompanyModel>(url);
  }

  updateCompanyDetails(companyObj: CompanyModel) {
    const url = `${this.companyApiUrl}/Companies/${companyObj.id}`;
    return this.http.put(url, companyObj);
  }

  addCompany(companyObj: CompanyModel) {
    const url = `${this.companyApiUrl}/Companies`;
    return this.http.post(url, companyObj);
  }

  deleteCompanyByID(companyID: number) {
    const url = `${this.companyApiUrl}/Companies/${companyID}`;
    return this.http.delete(url);
  }

  saveCompanySubscription(subscription: SubscriptionModel, companyID: number) {
    const url = `${this.companyApiUrl}/Companies/${companyID}/Subscription`;
    return this.http.post(url, subscription);
  }

  changeCompayStatus(data: any) {
    let companyId = data.id;
    const url = `${this.companyApiUrl}/Companies/${companyId}/ChangeStatus`;
    return this.http.put(url, data);
  }
  getCompaniesLite(searchTerm: string) {
    let url = `${this.companyApiUrl}/Companies/Lite`;
    const params: string[] = [];
    if (searchTerm && searchTerm.trim().length > 0) {
      params.push(`SearchTerm=${encodeURIComponent(searchTerm.trim())}`);
    }
    if (params.length > 0) {
      url += '?' + params.join('&');
    }
    return this.http.get<CompanyModel[]>(url);
  }
}
